import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IWhitelabelItem {
  readonly _id: string;
  readonly title: string;
  readonly siteName?: string; // todo: has to be adjusted according to the whitelabel item structure after it's defined
}

export interface IWhitelabelSelector {
  readonly id: string;
  readonly type: MESSAGES.WHITELABEL_SELECTOR;
  readonly items: IWhitelabelItem[];
  readonly nodeId: string;
  readonly pageSize: number;
  readonly rm: boolean;
  readonly role?: string;
}

export const createWhitelabelSelector = (data): IWhitelabelSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.WHITELABEL_SELECTOR,
  items: data.items,
  nodeId: data.nodeId,
  pageSize: data.pageSize,
  rm: Boolean(data.rm),
});
